import Konva from 'konva';
import * as state from '../state.js';
import { attachInteractive, pointerPos } from './_helpers.js';

let active = null;

export const pencil = {
  id: 'pencil',
  defaultProps: {},
  onPointerDown(engine) {
    const pos = pointerPos(engine);
    if (!engine.pointerInsideImage(pos)) return;
    active = new Konva.Line({
      points: [pos.x, pos.y],
      stroke: state.get('selectedColor'),
      strokeWidth: state.get('strokeWidth'),
      lineCap: 'round',
      lineJoin: 'round',
      tension: 0.5,
    });
    engine.contentLayer.add(active);
  },
  onPointerMove(engine) {
    if (!active) return;
    const pos = pointerPos(engine);
    active.points([...active.points(), pos.x, pos.y]);
    engine.contentLayer.batchDraw();
  },
  onPointerUp(engine) {
    if (!active) return;
    if (active.points().length < 4) {
      active.destroy();
    } else {
      active.remove();
      attachInteractive(engine, active);
    }
    engine.contentLayer.batchDraw();
    active = null;
  },
  apply(node, prop, value) {
    if (prop === 'color') {
      node.stroke(value);
    } else if (prop === 'strokeWidth') {
      node.strokeWidth(value);
    }
  },
};
